import { ObjectValues, InputHtmlProps } from '../types';

export const themes = {
  light: 'light',
  blue: 'blue',
} as const;

export type Checkbox = Omit<InputHtmlProps, 'value'> & {
  intermediate?: boolean;
  description?: string;
  extra?: React.ReactNode;
  isLabelVisible?: boolean;
  label?: string;
  name: string;
  value: string;
  showCustomError?: boolean;
  theme?: ObjectValues<typeof themes>;
  isUnderlined?: boolean;
};
